import React from 'react';
import { Shield, Clock, Heart, CheckCircle2, Users, Lock } from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: Shield,
      title: 'Finanzielle Sicherheit',
      description: 'Garantierte Auszahlung der vereinbarten Versicherungssumme für eine würdevolle Bestattung nach Ihren Wünschen.'
    },
    {
      icon: Heart,
      title: 'Angehörige entlasten',
      description: 'Ihre Liebsten müssen sich in der Trauerphase nicht mit Geldsorgen belasten – Sie haben vorgesorgt.'
    },
    {
      icon: Users,
      title: 'Persönliche Beratung',
      description: 'Unsere Experten hören zu, verstehen Ihre Situation und finden die passende Lösung für Sie.'
    },
    {
      icon: Clock,
      title: 'Schnelle Auszahlung',
      description: 'Im Ernstfall erfolgt die Auszahlung schnell und unkompliziert, damit alles nach Plan läuft.'
    },
    {
      icon: CheckCircle2,
      title: 'Transparente Konditionen',
      description: 'Keine versteckten Kosten, klare Beiträge und verständlich erklärte Bedingungen.'
    },
    {
      icon: Lock,
      title: 'Ohne Gesundheitsprüfung',
      description: 'Viele Tarife kommen ohne aufwendige Gesundheitsfragen aus – einfacher Zugang für alle.'
    }
  ];

  return (
    <section className="section section-light">
      <div className="container-custom">
        <div className="section-header fade-in">
          <p className="section-accent">✦ IHRE VORTEILE</p>
          <h2 className="headline-secondary">
            Vorteile unserer Beratung
          </h2>
          <p className="subheadline">
            Warum Sie bei uns richtig sind: Spezialisiert, einfühlsam und transparent.
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div key={index} className="benefit-card fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                <IconComponent className="icon-large" />
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
